import Axios from 'core/axios';

const state = {
  list: [],
  ready: false,
};

const getters = {
  hasCampaign: ({ list }) => list.length > 0,
};

const mutations = {
  'SET_CAMPAIGNS' (state, campaigns) {
    state.list = campaigns;
  },
  'SET_READY' (state, flag) {
    state.ready = flag;
  },
};

const actions = {
  fetch ({ commit }) {
    return Axios.get('campaign')
      .then(({ data }) => commit('SET_CAMPAIGNS', data.data))
      .finally(() => commit('SET_READY', true));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/stores/campaign.js